"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUsersByArea = void 0;
// eslint-disable-next-line import/prefer-default-export
function getUsersByArea(_a) {
    var url = _a.url, longitude = _a.longitude, latitude = _a.latitude, _b = _a.radius, radius = _b === void 0 ? 15000 : _b;
    return fetch(url + "/near-me?longitude=" + longitude + "&latitude=" + latitude + "&radius=" + radius).then(function (res) { return res.json(); });
}
exports.getUsersByArea = getUsersByArea;
//# sourceMappingURL=redAdapter.js.map